import { EnvironmentNames } from "enuns/EnvironmentNames";

type CookiesLGPDEnvType = "DEV" | "TST" | "UAT" | "PRD";
export const mapAppEnvToCookieEnv = (appEnv: EnvironmentNames): CookiesLGPDEnvType => {
  if (appEnv === EnvironmentNames.Develop) return 'DEV';
  if (appEnv === EnvironmentNames.Homolog) return 'UAT';

  return 'PRD';
};

export const getDomainIdByEnv = (appEnv: EnvironmentNames): string => {
  if (appEnv === EnvironmentNames.Homolog) return '93e6d317-fa45-4f55-b653-b6666c3ab51c';

  return '9fd88dbd-96db-4208-8c0d-6048a5207d7d';
};
